export default "__VITE_ASSET__BL93WXyO__"